import apiEndPoins from "../../utils/apiEndPoints";
import { apiCall } from "../../utils/httpClient";

const getEmployeeList = async (params) => {
    const data = await apiCall("post", apiEndPoins.CPEMPLOYEE, params);
    return data;
};

const companyService = {
    getEmployeeList
};

export default companyService;